import { Sparkles, MessageCircle, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { waLink } from "@/lib/siteConfig";

const benefits = [
  "File punching siap produksi",
  "Mockup desain digital sebelum dijalankan",
  "Konsultasi posisi & ukuran bordir",
];

export default function PromoHighlight() {
  return (
    <section
      id="promo"
      data-testid="promo-section"
      className="py-20 md:py-28 bg-[#2C2621] relative overflow-hidden"
    >
      {/* Decorative shapes */}
      <div className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-[#C97A4E]/20 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-[380px] h-[380px] rounded-full bg-[#8C5E35]/30 blur-3xl" />

      <div className="relative max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#C97A4E] border border-[#C97A4E]">
              <Sparkles className="w-4 h-4 text-white" />
              <span className="font-body text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-white">
                Promo Spesial
              </span>
            </div>

            <h2
              data-testid="promo-headline"
              className="mt-6 font-heading text-3xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] font-bold text-white"
            >
              Gratis Biaya Desain
              <br />
              <span className="text-[#E8B796]">& Punching File.</span>
            </h2>

            <p
              data-testid="promo-subheadline"
              className="mt-6 font-body text-base md:text-lg text-[#EFEBE1]/85 max-w-xl leading-relaxed"
            >
              Pesan minimal{" "}
              <span className="font-semibold text-white">50 pcs</span> dan tim
              desain kami akan menyiapkan file punching siap produksi —{" "}
              <span className="font-semibold text-[#E8B796]">gratis</span>,
              tanpa biaya tambahan apapun.
            </p>

            <ul className="mt-8 space-y-3">
              {benefits.map((b, idx) => (
                <li
                  key={idx}
                  data-testid={`promo-benefit-${idx}`}
                  className="flex items-start gap-3 text-[#EFEBE1]/90 font-body text-sm md:text-base"
                >
                  <CheckCircle2 className="w-5 h-5 text-[#E8B796] shrink-0 mt-0.5" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10">
              <Button
                asChild
                size="lg"
                data-testid="promo-cta-whatsapp"
                className="rounded-full bg-[#C97A4E] hover:bg-[#B86A3F] text-white font-semibold px-7 py-6 text-base shadow-xl shadow-black/40 transition-all duration-300 hover:-translate-y-0.5"
              >
                <a
                  href={waLink(
                    "Halo Lapak Bordir, saya mau klaim promo gratis desain & punching untuk pesanan 50 pcs ke atas."
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <MessageCircle className="w-5 h-5 mr-2" />
                  Klaim Promo Sekarang
                </a>
              </Button>
              <p className="mt-4 text-xs text-[#EFEBE1]/50 uppercase tracking-widest">
                *Berlaku untuk pesanan baru. Penawaran dapat berubah sewaktu-waktu.
              </p>
            </div>
          </div>

          {/* Big number callout */}
          <div className="lg:col-span-5">
            <div className="relative aspect-square max-w-md mx-auto rounded-3xl bg-gradient-to-br from-[#C97A4E] to-[#8C5E35] p-10 flex flex-col justify-between shadow-2xl shadow-black/40">
              <div>
                <div className="text-xs uppercase tracking-[0.25em] text-white/80 font-semibold">
                  Hemat Hingga
                </div>
                <div className="font-heading text-7xl md:text-8xl font-bold text-white leading-none mt-3">
                  100%
                </div>
                <div className="font-heading text-lg text-white/90 mt-2">
                  Biaya Desain &<br />Punching File
                </div>
              </div>
              <div className="border-t border-white/20 pt-5">
                <div className="font-body text-xs uppercase tracking-widest text-white/70">
                  Syarat
                </div>
                <div className="font-heading text-xl font-semibold text-white mt-1">
                  Pesanan ≥ 50 pcs
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
